import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";

import { AcceptAppScreenStyle } from "./accept-app-screen-style";
import { UserDataAndState, isUserData } from "common/Database";
import { getAppFacilities } from "webapp/lib/app-renderer";
import AppIcon from "common/app-icon";
import OrgsScreen from "designer/apps/orgs/orgs-screen/orgs-screen";
import { RootState } from "store/types";
import { trackEvent } from "analytics";
import { AcceptInviteBody } from "common/firebase-function-types";

interface RouteProps {
    readonly inviteID: string | undefined;
    readonly appTitle: string | undefined;
}

interface Props extends RouteComponentProps<RouteProps> {
    userData: UserDataAndState;
}
interface State {
    current: "start" | "accepting" | "success" | "fail";
    message: string | undefined;
}

class AcceptAppScreenImpl extends React.PureComponent<Props, State> {
    public state: State = {
        current: "start",
        message: undefined,
    };

    private onAccept = async () => {
        const { userData, match } = this.props;
        if (!isUserData(userData) || match.params.inviteID === undefined) return;

        this.setState({ current: "accepting" });

        const f = getAppFacilities();
        const body: AcceptInviteBody = { acceptCode: match.params.inviteID };
        const result = await f.callAuthCloudFunction("acceptAppInvite", body);
        if (result === undefined) {
            this.setState({ current: "fail" });
            return;
        }

        const json = await result.json();
        if (json.success === true) {
            this.setState({ current: "success" });
            this.props.history.push("/");
            trackEvent("app invite accepted", { user_id: userData.id, app_id: json.appID });
        } else {
            this.setState({ current: "fail", message: json.reason });
        }
    };

    public render(): React.ReactNode {
        return (
            // FIXME: We shouldn't be using the orgs screen here, of course
            <OrgsScreen loading={false}>
                <AcceptAppScreenStyle>
                    <div className="aiss-main-area">
                        <div>
                            You have been invited to accept the Glide app{" "}
                            <span>{this.props.match.params.appTitle}</span>.
                        </div>
                        <button onClick={this.onAccept} disabled={this.state.current !== "start"}>
                            <AppIcon icon="44-04-party-confetti" size={24} />
                            <div>Accept App</div>
                        </button>
                        {this.state.message !== undefined && <div className="aiss-error">{this.state.message}</div>}
                    </div>
                </AcceptAppScreenStyle>
            </OrgsScreen>
        );
    }
}

const mapState = (state: RootState) => ({
    userData: state.userData,
});

const AcceptAppScreen = connect(mapState)(AcceptAppScreenImpl);
export default AcceptAppScreen;
